export default __webpack_public_path__ + "static/media/csv.f75b9526.jpg";